import React, { Dispatch, SetStateAction } from 'react';
import { DownloadOutlined } from '@ant-design5/icons';
import { Button } from 'components/ui';

import { ValidateImageMetadataFileMutationResult } from 'types/atlas-graphql';
import { Steps } from '../UploadInspectionDataModal';
import { AdditionalInfoText, ButtonContainer, ErrorText } from '../UploadInspectionDataModal.style';

export type ImageDetailsValidationProps = ValidateImageMetadataFileMutationResult['data'] & {
  fileName: string;
  setStep: Dispatch<SetStateAction<Steps>>;
  setUploadErrors: Dispatch<
    SetStateAction<{
      summary: boolean;
      imageDetails: boolean;
    }>
  >;
};

export const Validation: React.FC<ImageDetailsValidationProps> = ({
  validateImageMetadataFile,
  fileName,
  setStep,
  setUploadErrors,
}) => {
  if (!validateImageMetadataFile) {
    return null;
  }
  const { draftImages, errorFileUrl, failureCount } = validateImageMetadataFile;

  const handleClickReupload = () => {
    setStep(Steps.DetailsUpload);
    setUploadErrors(uploadErrors => ({ ...uploadErrors, imageDetails: false }));
  };

  return (
    <>
      <p>
        {draftImages?.length ?? 0} image detail mapping{draftImages.length === 1 ? '' : 's'}{' '}
        validated.
      </p>
      <ErrorText>
        <strong>
          {failureCount} row{failureCount === 1 ? '' : 's'} in {fileName} contained invalid or
          incomplete data.
        </strong>
        <br />
        <p>
          Please use the button below to download the error file. Then complete the missing data and
          upload again.
        </p>
      </ErrorText>
      <Button icon={<DownloadOutlined />} href={errorFileUrl}>
        Download Error File
      </Button>
      <AdditionalInfoText>
        Note: Horizon requires the image details to be formatted in a way that is compatible with
        our system. For more information on configured inspection details uploads, please visit our{' '}
        <a
          href="https://guide.skyspecs.com/horizon/-MPobGVTLxgvA9kxtck7/"
          target="_blank"
          rel="noopener noreferrer"
        >
          User Guide
        </a>
        .
      </AdditionalInfoText>
      <ButtonContainer>
        <Button type="primary" onClick={handleClickReupload}>
          Reupload
        </Button>
      </ButtonContainer>
    </>
  );
};
